import { Typography, Box, Stack } from "@mui/material";
import { Man, Woman } from "iconsax-react";

const SegmentList = ({
  sharingType,
  segmentType,
  getGuest = () => {},
  dataResort,
  handleOnDrag = () => {},
  isDragged = false,
  draggedItem,
  handleDragOver = () => {},
}) => {
  return (
    <>
      {getGuest(dataResort, segmentType, sharingType).length > 0 && (
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: "14px",
            color: "#475467",
            marginTop: "6px",
          }}>
          {sharingType}
        </Typography>
      )}

      {getGuest(dataResort, segmentType, sharingType).map((user) => (
        <>
          <div draggable onDragStart={(e) => handleOnDrag(e, user)}>
            <Box
              sx={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "flex-start",
                width: "auto",
                height: "auto",
                border: "1px solid #EAECF0",
                borderRadius: "99px",
                backgroundColor:
                  isDragged && draggedItem === user?.Id ? "#66C7D1" : "#FFFFFF",
                padding: "10px",
                cursor: "grab",
              }}>
              <Stack direction="row">
                {user.Guest_ID__r?.Guest_FullName__r?.Gender__c === "Female" ? (
                  <Woman
                    color="#010671"
                    style={{
                      padding: "4px",
                      background: "#ECEDF8",
                      borderRadius: "1332px",
                    }}
                  />
                ) : (
                  <Man
                    color="#337D96"
                    style={{
                      padding: "4px",
                      background: "#EFFCF9",
                      borderRadius: "1332px",
                    }}
                  />
                )}
                <Typography
                  sx={{
                    marginLeft: "5px",
                    display: "flex",
                    alignItems: "center",
                    color: "#00023F",
                    fontWeight: 400,
                    fontSize: "16px",
                  }}>
                  {user.Guest_ID__r?.Guest_FullName__r?.Name}
                </Typography>
              </Stack>
            </Box>
          </div>
        </>
      ))}
    </>
  );
};
export default SegmentList;
